import Container from '@/util/container';
import projects from '@/util/projects.json';
import { SiGithub } from '@icons-pack/react-simple-icons';
import { Link } from 'lucide-react';

import './projects.css';
import Image from './image';

export function Projects() {
  return (
    <div className="projects">
      {projects
        .sort((a, b) => b.date - a.date)
        .map((project) => (
          <Container className="project-card" key={project.title}>
            <div className="">
              <div className="project-layout">
                <div className="project-image">
                  <Image src={project.image} height={200} width={350} />
                </div>
                <div className="project-copy">
                  <h3>{project.title}</h3>
                  <p className="my-2">{project.description}</p>
                  <p className="text-sm text-gray-400 mb-2">
                    {new Date(project.date).toLocaleDateString('default', {
                      month: 'short',
                      year: 'numeric',
                    })}
                  </p>
                  <div className="flex flex-row">
                    {project.github ? (
                      <a
                        href={project.github}
                        className="mr-4"
                        target="_blank"
                      >
                        <SiGithub width={18} />
                      </a>
                    ) : null}
                    {project.link && (
                      <a
                        href={project.link}
                        target="_blank"
                      >
                        <Link width={18} />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Container>
        ))}
    </div>
  );
}

export default Projects;
